<script setup>
import { ref, onMounted } from 'vue';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { setColorTheme } from 'dashboard/helper/themeHelper';

const isDark = ref(false);

const updateIsDark = () => {
  isDark.value = document.body.classList.contains('dark');
};

onMounted(() => {
  updateIsDark();
});

const toggleTheme = () => {
  const newScheme = isDark.value ? 'light' : 'dark';
  LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_SCHEME, newScheme);
  setColorTheme(newScheme === 'dark');
  updateIsDark();
};
</script>

<template>
  <button
    class="size-8 rounded-lg hover:bg-n-alpha-1 flex-shrink-0 grid place-content-center"
    :title="isDark ? 'Light mode' : 'Dark mode'"
    @click="toggleTheme"
  >
    <span v-if="isDark" class="i-lucide-sun size-4 text-n-slate-11" />
    <span v-else class="i-lucide-moon size-4 text-n-slate-11" />
  </button>
</template>
